import { captureRedirectTrackingParamsFromUrl, ensureMetaFbcCookie } from '~/utils/eventTracking'

const REDIRECT_SUB_DOMAIN_QUERY_KEY = 'redirectSubDomain'

export default defineNuxtPlugin(() => {
  if (!process.client) return

  const currentUrl = new URL(window.location.href)
  const trackingContext = captureRedirectTrackingParamsFromUrl(currentUrl)
  const { redirectSubDomain, query = {} } = trackingContext

  // Rebuild the Meta _fbc cookie on the main domain after redirect handoff.
  ensureMetaFbcCookie(currentUrl, trackingContext)

  if (!redirectSubDomain) return

  currentUrl.searchParams.delete(REDIRECT_SUB_DOMAIN_QUERY_KEY)
  Object.entries(query).forEach(([key, value]) => {
    if (!currentUrl.searchParams.get(key)) {
      currentUrl.searchParams.set(key, value)
    }
  })

  const cleanedUrl = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`
  window.history.replaceState({}, '', cleanedUrl)
})
